module.exports = __webpack_public_path__ + "static/media/Practicum-content-illustration.24f45329.svg";